'use client';

import { Building2, TriangleAlert } from 'lucide-react';

import { api } from '@/lib/api';
import { clearImpersonation } from '@/lib/platform/impersonation';

export function PlatformScopeBanner() {
  return (
    <div className="sticky top-0 z-40 flex h-9 items-center justify-center gap-2 border-b border-line bg-card px-4 text-xs font-semibold text-ink">
      <Building2 size={14} className="shrink-0" aria-hidden />
      <span className="min-w-0 truncate">All tenants. This console is the platform, not one agency desk.</span>
    </div>
  );
}

export function ImpersonationBanner({ agencyName }: { agencyName: string }) {
  return (
    <div className="sticky top-0 z-40 flex h-9 items-center justify-center gap-3 bg-warning px-4 text-xs font-semibold text-slate-950">
      <TriangleAlert size={14} className="shrink-0" aria-hidden />
      <span className="min-w-0 truncate">This agency only: {agencyName}. Rows here belong to this tenant.</span>
      <button
        type="button"
        className="shrink-0 rounded-full bg-slate-950 px-3 py-1 text-[11px] font-semibold text-white"
        onClick={() => {
          void api('/api/platform/impersonation', { method: 'DELETE' })
            .finally(() => {
              clearImpersonation();
              window.location.href = '/super-admin';
            });
        }}
      >
        Exit impersonation
      </button>
    </div>
  );
}
